import type { SVGProps } from "react";

const Primary = (props: SVGProps<SVGSVGElement>) => (
  <svg width="220" height="166" viewBox="0 0 220 166" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="110" cy="80" r="80" fill="url(#paint0_linear_1052_23253)" />
    <circle cx="18" cy="12" r="8" fill="white" />
    <circle cx="198" cy="142" r="6" fill="white" />
    <circle cx="25" cy="138" r="10" fill="white" />
    <circle cx="210" cy="46" r="10" fill="white" />
    <circle cx="191" cy="11" r="7" fill="white" />
    <g filter="url(#filter0_dd_1052_23253)">
      <rect x="27" y="22" width="166" height="104" rx="7.25581" fill="url(#paint1_linear_1052_23253)" />
      <rect x="41.0698" y="46.186" width="29.0233" height="21.7674" rx="2.4186" fill="#C6C0FF" />
      <circle cx="166.837" cy="53.4419" r="12.093" fill="#C6C0FF" />
      <circle cx="152.325" cy="53.4419" r="12.093" fill="#C6C0FF" />
      <path
        d="M41.0698 110.279C41.0698 108.943 42.1527 107.86 43.4884 107.86H67.6745C69.0102 107.86 70.0931 108.943 70.0931 110.279C70.0931 111.615 69.0102 112.698 67.6745 112.698H43.4884C42.1527 112.698 41.0698 111.615 41.0698 110.279Z"
        fill="#C6C0FF"
      />
      <path
        d="M77.3489 110.279C77.3489 108.943 78.4317 107.86 79.7675 107.86H103.954C105.289 107.86 106.372 108.943 106.372 110.279C106.372 111.615 105.289 112.698 103.954 112.698H79.7675C78.4317 112.698 77.3489 111.615 77.3489 110.279Z"
        fill="#C6C0FF"
      />
      <path
        d="M113.628 110.279C113.628 108.943 114.711 107.86 116.047 107.86H140.233C141.568 107.86 142.651 108.943 142.651 110.279C142.651 111.615 141.568 112.698 140.233 112.698H116.047C114.711 112.698 113.628 111.615 113.628 110.279Z"
        fill="#C6C0FF"
      />
      <path
        d="M149.907 110.279C149.907 108.943 150.99 107.86 152.326 107.86H176.512C177.847 107.86 178.93 108.943 178.93 110.279C178.93 111.615 177.847 112.698 176.512 112.698H152.326C150.99 112.698 149.907 111.615 149.907 110.279Z"
        fill="#C6C0FF"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_1052_23253"
        x="7"
        y="22"
        width="206"
        height="144"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23253" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23253" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23253" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23253" result="effect2_dropShadow_1052_23253" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23253" result="shape" />
      </filter>
      <filter
        id="filter1_b_1052_23253"
        x="74"
        y="84"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1052_23253" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1052_23253" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_1052_23253" x1="110" y1="0" x2="110" y2="160" gradientUnits="userSpaceOnUse">
        <stop stopColor="#EAE6FF" />
        <stop offset="1" stopColor="#D6D3E7" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_23253"
        x1="32.7809"
        y1="124.769"
        x2="29.758"
        y2="29.5842"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9D7FE" />
        <stop offset="1" stopColor="#F4EBFF" />
      </linearGradient>
    </defs>
  </svg>
);

const Gray = (props: SVGProps<SVGSVGElement>) => (
  <svg width="220" height="166" viewBox="0 0 220 166" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="110" cy="80" r="80" fill="url(#paint0_linear_1052_23268)" />
    <circle cx="18" cy="12" r="8" fill="white" />
    <circle cx="198" cy="142" r="6" fill="white" />
    <circle cx="25" cy="138" r="10" fill="white" />
    <circle cx="210" cy="46" r="10" fill="white" />
    <circle cx="191" cy="11" r="7" fill="white" />
    <g filter="url(#filter0_dd_1052_23268)">
      <rect x="27" y="22" width="166" height="104" rx="6" fill="url(#paint1_linear_1052_23268)" />
      <rect x="41.0698" y="46.186" width="29.0233" height="21.7674" rx="2" fill="#F0F1F3" />
      <circle cx="166.837" cy="53.4418" r="12.093" fill="#AAABAE" />
      <circle cx="152.325" cy="53.4419" r="12.093" fill="#F0F1F3" />
      <path
        d="M41.0698 110.279C41.0698 108.943 42.1527 107.86 43.4884 107.86H67.6745C69.0102 107.86 70.0931 108.943 70.0931 110.279C70.0931 111.615 69.0102 112.698 67.6745 112.698H43.4884C42.1527 112.698 41.0698 111.615 41.0698 110.279Z"
        fill="#F0F1F3"
      />
      <path
        d="M77.3489 110.279C77.3489 108.943 78.4317 107.86 79.7675 107.86H103.954C105.289 107.86 106.372 108.943 106.372 110.279C106.372 111.615 105.289 112.698 103.954 112.698H79.7675C78.4317 112.698 77.3489 111.615 77.3489 110.279Z"
        fill="#F0F1F3"
      />
      <path
        d="M113.628 110.279C113.628 108.943 114.711 107.86 116.047 107.86H140.233C141.568 107.86 142.651 108.943 142.651 110.279C142.651 111.615 141.568 112.698 140.233 112.698H116.047C114.711 112.698 113.628 111.615 113.628 110.279Z"
        fill="#F0F1F3"
      />
      <path
        d="M149.907 110.279C149.907 108.943 150.99 107.86 152.326 107.86H176.512C177.847 107.86 178.93 108.943 178.93 110.279C178.93 111.615 177.847 112.698 176.512 112.698H152.326C150.99 112.698 149.907 111.615 149.907 110.279Z"
        fill="#F0F1F3"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_1052_23268"
        x="7"
        y="22"
        width="206"
        height="144"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23268" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23268" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23268" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23268" result="effect2_dropShadow_1052_23268" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23268" result="shape" />
      </filter>
      <filter
        id="filter1_b_1052_23268"
        x="74"
        y="84"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1052_23268" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1052_23268" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_1052_23268" x1="110" y1="0" x2="110" y2="160" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F3EDFA" />
        <stop offset="1" stopColor="#EBEAED" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_23268"
        x1="32.7809"
        y1="124.769"
        x2="29.758"
        y2="29.5842"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E4E7EC" />
        <stop offset="1" stopColor="#F9FAFB" />
      </linearGradient>
    </defs>
  </svg>
);

export const IllustrationCreditCard = {
  Primary,
  Gray,
};
